import { colors } from "@styles/colors";
import React, { ReactNode } from "react";
import { Card } from "tamagui";
import { useSkinV2Page } from "@screen/Home/pages/GasShop/skin";

interface CardProps {
  children: ReactNode;
  bg?: string;
  border?: string;
  borderRadius?: number;
  id?: string;
}

const RadiusCard: React.FC<CardProps> = ({ children, bg = colors.light, border = colors.light, borderRadius = 20, id }) => {
  /* V2：圓角 24、無邊線、單層淺陰影（與 SkinCard／ListContainer 同一款外框）。
     V1 的 elevate 陰影（0.1 不透明、四邊擴散）疊在漸層底色上會糊成一圈灰暈。 */
  const skinV2 = useSkinV2Page();
  if (skinV2) {
    return (
      <Card
        id={id}
        backgroundColor={bg}
        borderRadius={24}
        padding={16}
        style={{ boxShadow: "0 2px 10px -4px rgba(21, 101, 192, 0.10)" }}>
        {children}
      </Card>
    );
  }
  return (
    <Card
      id={id}
      backgroundColor={bg}
      borderColor={border}
      borderWidth={1}
      borderRadius={borderRadius}
      padding={16}
      shadowColor="black"
      shadowOpacity={0.1}
      shadowRadius={10}
      shadowOffset={{ width: 0, height: 4 }}
      elevate>
      {children}
    </Card>
  );
};

export default RadiusCard;
